module.exports = __webpack_public_path__ + "static/media/declaracion.be416f69.pdf";